import { useState } from 'react';

const useModal = () => {
    const [isVisible, setModalVisible] = useState(false);
    const openModal = () => setModalVisible(true);
    const hideModal = () => setModalVisible(false);

    return [isVisible, openModal, hideModal];
};

export default useModal;